import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from "@shared/services/common-data.service";
import { response } from 'express';
import { error } from 'protractor';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent implements OnInit {

  activeTab = 'north';
  data = [];
  activeTopicId = 0;
  url = '/karvy-branches';

  constructor(private apiService: ApiService, 
              public router: Router,
              private commonDataService: CommonDataService) { }

  ngOnInit() {
    if (this.router.url === '/karvy-branches') {
      this.url = Urls.getKarvyBranches;
    } else if (this.router.url === '/amc-branches') {
      this.url = Urls.getAmcBranches;
      this.activeTab = 'west';
    } else {
      this.url = Urls.getYourAdvisor;
    }
    this.getData();
    this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getData = () => {
    this.commonDataService.loaderStatus.next(true);
  this.apiService.postData(this.url, {region : this.activeTab}).subscribe(
    response => {
      this.data = response.data.finalList;
      this.commonDataService.loaderStatus.next(false);
    },
    error => {
      this.commonDataService.loaderStatus.next(false);
    }
  )
  }

  setActive = (val) => {
    this.activeTab = val;
    this.activeTopicId = 0;
    this.getData();
  }

  setActiveState = (id) => {
    this.activeTopicId = id;
  }

}
